<div class="accordion__container">
  <form [formGroup]="group">
    <h3>Business Address</h3>

    <div class="accordion__grid">
      <div>
        <mat-form-field>
          <mat-label>Address Line 1</mat-label>
          <input matInput formControlName="addressLine1" id="addressLine1" type="text" title="Business Address 1" />
          <mat-error comFormMessageName="addressLine1">Please enter the first line of an address</mat-error>
        </mat-form-field>
      </div>
      <div>
        <mat-form-field>
          <mat-label>Address Line 2</mat-label>
          <input matInput formControlName="addressLine2" id="addressLine2" type="text" title="Business Address 2" />
        </mat-form-field>
      </div>
      <div>
        <mat-form-field>
          <mat-label>Address Line 3</mat-label>
          <input matInput formControlName="addressLine3" id="addressLine3" type="text" title="Business Address 3" />
        </mat-form-field>
      </div>
    </div>
    <div class="accordion__grid">
      <div>
        <mat-form-field>
          <mat-label>Address Line 4</mat-label>
          <input matInput formControlName="addressLine4" id="addressLine4" type="text" title="Business Address 4" />
        </mat-form-field>
      </div>
      <div>
        <mat-form-field>
          <mat-label>Postcode</mat-label>
          <input matInput formControlName="postCode" id="postCode" type="text" title="Business Address Postcode" />
        </mat-form-field>
      </div>
      <div>
        <mat-form-field>
          <mat-label>Country</mat-label>
          <mat-select formControlName="country" id="country" title="Business Address Country">
            @for (country of countries; track $index) {
              <mat-option [value]="country.name">{{ country.name }}</mat-option>
            }
          </mat-select>
          <mat-error comFormMessageName="country">Please select a country</mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="accordion__grid">
      <div>
        <mat-form-field>
          <mat-label>County</mat-label>
          <mat-select formControlName="county" id="county" title="Business Address County">
            @for (county of counties; track $index) {
              <mat-option [value]="county.key">{{ county.value }}</mat-option>
            }
          </mat-select>
          <mat-error comFormMessageName="county">Please select a county</mat-error>
        </mat-form-field>
      </div>
      <div>
        <mat-form-field>
          <mat-label>Telephone</mat-label>
          <input matInput formControlName="telephone" id="telephone" type="text" title="Phone number" />
          <mat-error comFormMessageName="telephone">Please enter a valid telephone number</mat-error>
        </mat-form-field>
      </div>
      <div>
        <mat-form-field>
          <mat-label>Mobile</mat-label>
          <input matInput formControlName="mobile" id="mobile" type="text" title="`Mobile number" />
          <mat-error comFormMessageName="mobile">Please enter a valid mobile number</mat-error>
        </mat-form-field>
      </div>
    </div>

    <div>
      <mat-form-field>
        <mat-label>Admin Email</mat-label>
        <input matInput formControlName="email" id="email" type="text" title="Admin email" />
        <mat-error comFormMessageName="email" validation="required">Please enter an email address</mat-error>
        <mat-error comFormMessageName="email" validation="pattern">Please enter a valid email address</mat-error>
      </mat-form-field>
    </div>

    @if (isPRSAccount()) {
      <hr />
      <h3>Registered Address</h3>
      <div class="accordion__grid">
        <div>
          <mat-form-field>
            <mat-label>Address Line 1</mat-label>
            <input matInput formControlName="regAddressLine1" id="regAddressLine1" type="text" title="Registered Address 1" />
            <mat-error comFormMessageName="regAddressLine1">Please enter the first line of an address</mat-error>
          </mat-form-field>
        </div>
        <div>
          <mat-form-field>
            <mat-label>Address Line 2</mat-label>
            <input matInput formControlName="regAddressLine2" id="regAddressLine2" type="text" title="Registered Address 2" />
          </mat-form-field>
        </div>
        <div>
          <mat-form-field>
            <mat-label>Address Line 3</mat-label>
            <input matInput formControlName="regAddressLine3" id="regAddressLine3" type="text" title="Registered Address 3" />
          </mat-form-field>
        </div>
      </div>

      <div class="accordion__grid">
        <div>
          <mat-form-field>
            <mat-label>Address Line 4</mat-label>
            <input matInput formControlName="regAddressLine4" id="regAddressLine4" type="text" title="Registered Address 4" />
          </mat-form-field>
        </div>
        <div>
          <mat-form-field>
            <mat-label>Postcode</mat-label>
            <input matInput formControlName="regPostCode" id="regPostCode" type="text" title="Registered Address Postcode" />
          </mat-form-field>
        </div>
        <div>
          <mat-form-field>
            <mat-label>Country</mat-label>
            <mat-select formControlName="regCountry" id="regCountry" title="Regsitered Address Country">
              @for (country of countries; track $index) {
                <option [value]="country.name">{{ country.name }}</option>
              }
            </mat-select>
            <mat-error comFormMessageName="regCountry">Please select a country</mat-error>
          </mat-form-field>
        </div>
      </div>

      <mat-form-field>
        <mat-label>County</mat-label>
        <mat-select formControlName="regCounty" id="regCounty" title="Regsitered Address County">
          @for (county of counties; track $index) {
            <option [value]="county.key">{{ county.value }}</option>
          }
        </mat-select>
        <mat-error comFormMessageName="regCounty">Please select a county</mat-error>
      </mat-form-field>
    }
    @if (showPrsQuestions) {
      <h3>ADDITIONAL QUESTIONS</h3>

      <p>
        Must you register with, or get approval from, the PRS regulatory authority in your country?<br />
        If the answer is "yes", please provide details of the content of your registration, or authorisation, or approval (for example, your
        registration authorisation number).<b>*</b>
      </p>
      <mat-form-field>
        <textarea matInput formControlName="q1" title="Additional Question 1"></textarea>
      </mat-form-field>
      <p>Please provide the names and other details of the regulatory authorities for PRS in your country.<b>*</b></p>
      <mat-form-field>
        <textarea matInput formControlName="q2" title="Additional Question 2"></textarea>
      </mat-form-field>
      <p>
        Have you or your company ever <strong>not</strong> complied with the PRS regulations in your country?<br />
        If the answer is "yes" please provide full details.<b>*</b>
      </p>
      <mat-form-field>
        <textarea matInput formControlName="q3" title="Additional Question 3"></textarea>
      </mat-form-field>
    }
    <div class="accordion__buttons">
      @if (group.disabled) {
        <button mat-raised-button (click)="edit(group)" [disabled]="!canEdit">EDIT</button>
      }
      @if (isError) {
        <div [innerHtml]="errorMessages | arrayToList"></div>
      }
      @if (!group.disabled) {
        <button mat-raised-button (click)="cancel(group)">CANCEL</button>
        <button mat-raised-button [disabled]="!group.valid" (click)="save(group.value)">UPDATE</button>
      }
    </div>
  </form>
</div>
